import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  RadioGroup,
  FormControlLabel,
  Radio,
  Box,
  Typography,
} from '@mui/material';
import { CHANGE_OWNER_URL } from '../../utils';

const TransferWorkDialog = ({ open, onClose, names = [], order, fetchOrders = () => {} }) => {
  const [selectedName, setSelectedName] = useState();
  // Handle radio selection
  const handleRadioChange = (event) => {
    setSelectedName(event.target.value);
  };

  useEffect(() => {
    if(order){
      setSelectedName(order?.owner_id)
    }
  }, [order])

  const handleConfirm = async (owner_id, order_id) => {
    if (!owner_id) {
      alert('Please select a person to transfer work to.');
      return;
    }
  
    try {
      const response = await fetch(`${CHANGE_OWNER_URL}?id=${order_id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}` // Add token if needed
        },
        body: JSON.stringify({ owner_id })
      });
  
      if (!response.ok) {
        throw new Error('Failed to transfer work');
      }
  
      const data = await response.json();
      alert(data.message || 'Work transferred successfully');
      onClose(); // Close the modal or dialog if applicable
      fetchOrders();
    } catch (error) {
      console.error('Error transferring work:', error);
      alert('Failed to transfer work. Please try again.');
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>
        <Typography variant="h5" color="#BA9F52">
          Transfer Work
        </Typography>
      </DialogTitle>
      <DialogContent dividers>
        <RadioGroup value={selectedName} onChange={handleRadioChange}>
          {names.map((name, index) => (
            <FormControlLabel
              key={name.full_name + index}
              value={name.id}
              control={<Radio color="primary" />}
              label={name.full_name}
              sx={{ mb: 1 }}
            />
          ))}
        </RadioGroup>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="inherit" sx={{ color: '#BA9F52' }}>
          Cancel
        </Button>
        <Button
          onClick={() => handleConfirm(selectedName, order?.id)}
          variant="contained"
          sx={{ bgcolor: '#BA9F52', color: '#FFF', '&:hover': { bgcolor: '#BA9F52' } }}
        >
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TransferWorkDialog;
